import { Dialog, Button, Text, Flex } from "@radix-ui/themes";
import styles from "./Agents.module.scss";
import { useTeamsWithAgents } from "../../api/useTeams";

interface DeleteTeamDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  teamName: string;
  hasAgents: boolean;
  onConfirmDelete: () => Promise<void>;
}

export function DeleteTeamDialog({
  open,
  onOpenChange,
  teamName,
  hasAgents,
  onConfirmDelete,
}: DeleteTeamDialogProps) {
  const { refetch: refetchTeamsWithAgents } = useTeamsWithAgents(true);

  const handleDelete = async () => {
    await onConfirmDelete();
    await refetchTeamsWithAgents();
  };

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Content style={{ maxWidth: 450 }}>
        <Dialog.Title>Delete Team</Dialog.Title>
        <Dialog.Description size="2" mb="4">
          {hasAgents ? (
            <Text color="red">
              Cannot delete team "{teamName}" because it still has agents assigned.
              Please remove all agents from the team first.
            </Text>
          ) : (
            <Text>
              Are you sure you want to delete team "{teamName}"? This action
              cannot be undone.
            </Text>
          )}
        </Dialog.Description>

        <Flex gap="3" justify="end">
          <Dialog.Close>
            <Button
              variant="soft"
              color="gray"
              className={styles.secondaryButton}
            >
              Cancel
            </Button>
          </Dialog.Close>
          {!hasAgents && (
            <Button
              variant="solid"
              color="red"
              onClick={handleDelete}
            >
              Delete Team
            </Button>
          )}
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
} 